module.exports = __webpack_public_path__ + "static/media/stuffedAnimals.520eada9.png";